<template>
  <Course style="margin-top: -81px"></Course>
</template>
<script>
  import Course from '@/page/modules/course/detail'
  export default {
    components: { Course }
  }
</script>



// WEBPACK FOOTER //
// src/pages/front/course/pageCourse.vue